import type { CodeResult } from '../types/quiz'

export const codes: CodeResult[] = [
  {
    key: 'presencia',
    number: '01',
    name: 'Presencia Magnética',
    title: 'Volver a habitarte.',
    body: [
      'Reconectar con tu cuerpo, tu respiración, tus emociones y tu capacidad de estar presente.',
      'Cuando dejamos de vivir únicamente desde la mente y comenzamos a escucharnos, podemos empezar a observar nuestras necesidades, emociones y decisiones con mayor claridad.',
    ],
    question: '¿Qué necesitas escuchar de ti que llevas demasiado tiempo ignorando?',
  },
  {
    key: 'confianza',
    number: '02',
    name: 'Confianza Irresistible',
    title: 'Volver a confiar en ti.',
    body: [
      'Observar las historias, comparaciones, miedos y patrones que pueden estar afectando la manera en que te ves y tomas decisiones.',
      'La confianza no significa sentirte perfecta. Significa aprender a reconocerte, valorarte y actuar desde tu propio criterio.',
    ],
    question: '¿Qué harías diferente si confiaras plenamente en tu capacidad?',
  },
  {
    key: 'alineacion',
    number: '03',
    name: 'Alineación Próspera',
    title: 'Unir conciencia y acción.',
    body: [
      'Porque saber lo que quieres no siempre significa estar actuando en dirección a ello.',
      'La alineación aparece cuando comienzas a conectar lo que piensas, lo que sientes, lo que deseas y las decisiones que tomas.',
    ],
    question:
      '¿Cuál es la decisión que sabes que necesitas tomar pero todavía estás postergando?',
  },
]

export const resultCopy: Record<
  CodeResult['key'],
  { paragraphs: string[] }
> = {
  presencia: {
    paragraphs: [
      'Tu resultado sugiere que en este momento podrías estar necesitando volver a escucharte.',
      'Quizás has estado demasiado enfocada en resolver, producir, cuidar o responder a las necesidades de los demás y has dejado poco espacio para ti.',
      'Tu siguiente nivel no necesariamente comienza haciendo más. Puede comenzar deteniéndote y reconectando contigo.',
    ],
  },
  confianza: {
    paragraphs: [
      'Tu resultado sugiere que una de las áreas que merece mayor atención en este momento es la relación que tienes contigo misma.',
      'Quizás sabes mucho más de lo que reconoces, pero todavía dudas de tus decisiones. Quizás te comparas, te exiges demasiado o tienes miedo de equivocarte.',
      'Tu siguiente nivel no requiere que seas perfecta. Requiere que comiences a confiar más en tu propia voz.',
    ],
  },
  alineacion: {
    paragraphs: [
      'Tu resultado sugiere que estás en un momento donde necesitas conectar mejor tus deseos con tus decisiones y acciones.',
      'Quizás tienes sueños, ideas y objetivos, pero te cuesta definir cuál es el siguiente paso.',
      'No siempre necesitamos hacer más. A veces necesitamos dejar de dispersarnos y comenzar a avanzar con intención.',
    ],
  },
}
